export const snakeCase = (str: string) =>
  typeof str === "string"
    ? str
        .replaceAll(/\s+/g, "_")
        .replaceAll(/([^_])([A-Z])/g, "$1_$2")
        .toLowerCase()
    : str;
